import script from "./app-amap-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-amap-search.vue?vue&type=script&setup=true&lang=ts"

import "./app-amap-search.vue?vue&type=style&index=0&id=8dbb0276&lang=scss"
import "./app-amap-search.vue?vue&type=style&index=1&id=8dbb0276&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dbb0276"]])

export default __exports__